import { acknowledgementId, type ProcedureAcknowledgeV1 } from '@gk/contracts'
import type { OverlayRow } from './db.ts'
import type { Projector } from './projectors.ts'

/** M16-I2 (docs/M16.md rule 2): the projection of procedure.acknowledge@1, a field FACT. "J'ai lu cette version" shows on this device at once, pending, with
 *  the command's instant, until the server's row replaces it; the pill of a job leaves at once too, with no signal. The id is the one the server derives
 *  from the person and the version (`acknowledgementId`), so the overlay and the server's row are one key, and a reading already in the mirror (another
 *  device, the workstation) is the same row. The person is the one acting: the payload names him, the server refuses anybody else. document.set_ask_reading@1
 *  is the publisher's intent: no projection (`none` in the registry). */
export const procedureAcknowledge: Projector = (cmd) => {
  const p = cmd.payload as ProcedureAcknowledgeV1
  const id = acknowledgementId(p.person_id, p.document_version_id)
  const row: OverlayRow = {
    key: `ops.procedure_acknowledgement:${id}`, table: 'ops.procedure_acknowledgement', id, command_id: cmd.command_id, op: 'insert',
    row: {
      id, org_id: cmd.org_id, site_id: cmd.site_id, person_id: p.person_id.toLowerCase(), document_version_id: p.document_version_id.toLowerCase(),
      acknowledged_at: cmd.occurred_at, actor_person_id: cmd.actor_person_id ?? null, _pending: true,
    },
  }
  return [row]
}
